import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../services/redux/app/Store';
import { checkNewCompletedTickets } from '../../../../services/redux/slices/ticket/completed-ticket-slice';
import { MenuInnerWithSub } from './MenuInnerWithSub';
import { MenuItem } from './MenuItem';
import { checkNewTickets } from '../../../../services/redux/slices/ticket/ticket-slice';

export function MenuInner() {
  const intl = useIntl();
  const { offerEnabled } = useAppSelector((state) => state.auth);
  const { data } = useAppSelector((state) => state.completedTicket);
  const { data: ticket } = useAppSelector((state) => state.ticketList);
  const dispatch = useAppDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(checkNewCompletedTickets());
    dispatch(checkNewTickets());

    const interval = setInterval(() => {
      dispatch(checkNewCompletedTickets());
      dispatch(checkNewTickets());
    }, 180000);
  
    return () => {
      clearInterval(interval);
    };
  }, [history.location]); 
  
  return (
    <>
      <MenuItem to="/dashboard" icon="/media/logos/logo-idefix.svg" logo />
      <div className="mx-5"></div>

      <MenuInnerWithSub title="Ürünlerim" to="/products" menuPlacement="bottom-start" menuTrigger="{default:'click', lg: 'hover'}">
        {/* PAGES */}
        <MenuItem to="/products/my-products/matching-products" title="Tümü" />
        <MenuItem to="/products/product-operations" title="Ürün İşlemleri" />
        <MenuItem to="/products/questions" title="Ürün Soruları" />
        <MenuItem to="/products/evaluation" title="Ürün Değerlendirmeleri" />
        <MenuItem to="/products/add-products/bulk-options" title="Marka Ekleme Talepleri" />
      </MenuInnerWithSub>

      <MenuItem title="Envanter" to="/inventory" />
      {/* PAGES */}

      <MenuInnerWithSub title="Sipariş" to="/orders" menuPlacement="bottom-start" menuTrigger="{default:'click', lg: 'hover'}">
        {/* PAGES */}
        <MenuItem to="/orders/orders-management" title="Siparişler" />
        <MenuItem to="/orders/cancelled" title="İptaller" />
        <MenuItem to="/orders/refund" title="İadeler" />
        <MenuItem to="/orders/cargo" title="Kargo İşlemleri" />
        <MenuItem to="/orders/questions" title="Sipariş Soruları" />
        <MenuItem to="/orders/order-evaluation" title="Sipariş Değerlendirmeleri" />
      </MenuInnerWithSub>

      <MenuInnerWithSub title="Finans" to="/finance" menuPlacement="bottom-start" menuTrigger="{default:'click', lg: 'hover'}">
        {/* PAGES */}
        <MenuItem to="/finance/vesting" title="Hak Ediş" />
        <MenuItem to="/finance/payment" title="Ödemeler" />
        <MenuItem to="/finance/invoices" title="Fatura İşlemleri" />
        <MenuItem to="/finance/invoice-requests" title="Fatura Talepleri" />
        <MenuItem to="/finance/current" title="Cari Hesap Ekstresi" />
        <MenuItem to="/finance/vendor-reconciliations" title="Dönem Mutabakatlarım" />
      </MenuInnerWithSub>

      <MenuInnerWithSub title="Kampanya" to="/campaigns" menuPlacement="bottom-start" menuTrigger="{default:'click', lg: 'hover'}">
        {/* PAGES */}
        <MenuItem to="/campaigns/list" title="Kampanyalar" />
        <MenuItem to="/campaigns/create" title="Kampanya Oluştur" />
        <MenuItem to="/campaigns/coupons" title="Kuponlarım" />
        {offerEnabled && <MenuItem to="/campaigns/commission-offers" title="Komisyon Tekliflerim" />}
      </MenuInnerWithSub>

      <MenuInnerWithSub title="Raporlar" to="/reports" menuPlacement="bottom-start" menuTrigger="{default:'click', lg: 'hover'}">
        {/* PAGES */}
        <MenuItem to="/reports/sales" title="Satış Raporları" />
        <MenuItem to="/reports/refund" title="İade Raporları" />
        <MenuItem to="/reports/cancel" title="İptal Raporları" />
        <MenuItem to="/reports/delayed" title="Geciken Sipariş Raporları" />
      </MenuInnerWithSub>

      <MenuItem
        to="/support"
        title={
          <span>
            Destek Talepleri
            {(data?.totalCount || ticket?.totalCount) ? (
              <Link to="/support/onlyUnRead">
                <span className="text-danger"> (Yeni Mesajınız Var)</span>
              </Link>
            ) : null}
          </span>
        }
      />
      <div className="menu-item me-lg-1">
        <a href="https://bilgimerkezi.idefix.com/" target="_blank" className="menu-link py-3 fs-5 fw-boldest">
          <span className="menu-title" style={{ color: '#006BDC' }}>
            idefix Bilgi Merkezi
          </span>
        </a>
      </div>
    </>
  );
}
